// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Link } from 'react-router-dom';
import './Navigation.scss';

@inject('userStore', 'componentStore')
@observer class Navigation extends Component<any, any> {

	constructor(props: any) {
		super(props);

		this.logout = this.logout.bind(this);
	}

	logout(e: any) {
		e.preventDefault();

		this.props.userStore.logout();
		this.props.componentStore.nav = false;
	}

	render() {
		return (
			<nav>
				<h1>change my mind.</h1>
				<ul>
					<li><Link to="/">Home</Link></li>

					{this.props.userStore.user ? 
						<li><Link to="/create-question">New Question</Link></li>
						: null}

					{this.props.userStore.user ? 
						<li><Link to="/matches">My Matches</Link></li>
						: null}
					
				</ul>
				{this.props.userStore.user ? 
					<div className="logout-wrapper">
						<p className="user-identity">logged in as <b>{this.props.userStore.user.username}</b></p>
						<button className="logout" onClick={this.logout}>Logout</button>
					</div>
					: null}
				
				<footer className="navigation-footer"><a target="_blank" href="https://tfranek.net">© Tobias Franek</a> | <Link to="/imprint">Imprint</Link></footer>
			</nav>
		)
	}
}

export default Navigation;